<template>
  <div class="vd-gl-content">
    <a-row class="vd-toolbar">
      <a-col class="vd-toolbar-right vd-bar">
        <a-form layout="inline">
          <a-form-item label="资料名">
            <a-input
              placeholder="资料名"
              v-model="name"
              @change="searchInput"
            />
          </a-form-item>
          <a-form-item label="资料状态">
            <a-select
              style="width: 104px;"
              v-model="status"
              @change="search"
              placeholder="资料状态"
            >
              <a-select-option :key="1"> 审核中</a-select-option>
              <a-select-option :key="2"> 审核通过</a-select-option>
              <a-select-option :key="3"> 使用中</a-select-option>
              <a-select-option :key="4"> 资料过期</a-select-option>
              <a-select-option :key="5"> 审核驳回</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="学科门类">
            <a-select
              style="width: 216px"
              v-model="category"
              @change="search"
              placeholder="学科门类"
            >
              <template v-for="item in subList">
                <a-select-option :key="item.id">
                  {{ item.nickname }}
                </a-select-option>
              </template>
            </a-select>
          </a-form-item>
          <a-form-item :wrapper-col="{ span: 24 }">
            <a-tooltip placement="top" title="搜索">
              <a-button type="primary" icon="search" @click="search" />
            </a-tooltip>
            <a-tooltip placement="top" title="重置选项">
              <a-button
                style="margin-left: 8px"
                type="link"
                icon="redo"
                @click="redo"
              />
            </a-tooltip>
          </a-form-item>
        </a-form>
      </a-col>
      <a-col>
        <a-form layout="inline">
          <a-form-item>
            <a-button-group>
              <a-button
                :type="is_my === 1 ? 'primary' : ''"
                @click="change_my(1)"
                >由我创建</a-button
              >
              <a-button
                :type="is_my === 0 ? 'primary' : ''"
                @click="change_my(0)"
                >他人创建</a-button
              >

              <a-button
                v-show="$AuthUtil.authRoute('/book/examine')"
                :type="is_my === 2 ? 'primary' : ''"
                @click="change_my(2)"
                >待审核资料
              </a-button>
            </a-button-group>
          </a-form-item>
          <a-form-item style="float: right;">
            <a-button
              type="primary"
              icon="cloud-upload"
              @click="upload_material"
              >上传资料</a-button
            >
          </a-form-item>
        </a-form>
      </a-col>
    </a-row>

    <a-table
      row-key="id"
      :data-source="list"
      :pagination="pagination"
      :loading="{
        size: 'large',
        spinning: tableSpinning,
      }"
      bordered
      :scroll="{ x: 1300 }"
    >
      <a-table-column
        title="资料名称"
        fixed="left"
        data-index="name"
        :width="100"
      />
      <a-table-column title="资料类型" align="center" data-index="type">
        <template slot-scope="text">
          {{ text === 1 ? '文本资料' : '视频资料' }}
        </template>
      </a-table-column>
      <a-table-column
        title="资料封面"
        align="center"
        style="max-width: 100px"
        data-index="head_pic"
      >
        <template slot-scope="text">
          <a-tooltip placement="left">
            <template slot="title">
              <img :src="text" alt="资料封面" />
            </template>
            <a-avatar :size="100" shape="square" :src="text">
              封面图丢失
            </a-avatar>
          </a-tooltip>
        </template>
      </a-table-column>
      <a-table-column
        title="资料到期时间"
        align="center"
        data-index="due_time"
      />
      <a-table-column title="创建人" align="center" data-index="a_code" />
      <a-table-column title="学科门类" align="center" data-index="c_nickname" />
      <a-table-column title="创建时间" align="center" data-index="add_time" />
      <a-table-column
        title="发布状态"
        data-index="status"
        fixed="right"
        align="center"
        :width="104"
      >
        <!-- 1 审核中 2 审核通过 3 使用中 4 资料过期-->
        <template slot-scope="text, record">
          <template v-if="text === 1">
            <a-badge status="warning" text="审核中" />
          </template>
          <template v-else-if="text === 2">
            <a-badge status="success" text="审核通过" />
          </template>
          <template v-else-if="text === 3">
            <a-badge status="processing" text="使用中" />
          </template>
          <template v-else-if="text === 4">
            <a-badge status="default" text="资料过期" />
          </template>
          <template v-else-if="text === 5">
            <a-tooltip placement="top" :title="'驳回:' + record.reason">
              <a-badge status="error" text="被驳回" />
            </a-tooltip>
          </template>
        </template>
      </a-table-column>
      <a-table-column title="操作" align="center" fixed="right" :width="100">
        <template slot-scope="record">
          <!--这个要 + 权限-->
          <template v-if="is_my === 0">
            <a-tooltip placement="top" title="查看资料">
              <a-icon
                style="font-size: 22px"
                type="eye"
                @click="seeMaterial(record)"
              ></a-icon>
            </a-tooltip>
          </template>
          <template v-if="is_my === 1">
            <a-tooltip placement="top" title="查看资料">
              <a-icon
                style="font-size: 22px"
                type="eye"
                @click="seeMaterial(record)"
              ></a-icon>
            </a-tooltip>
            <template v-if="record.status === 3">
              <a-tooltip placement="top" title="查看关联活动">
                <a-icon
                  style="font-size: 22px;margin-left: 8px"
                  type="link"
                  @click="getRelation(record)"
                ></a-icon>
              </a-tooltip>
            </template>
            <template v-if="record.status === 5">
              <a-tooltip placement="top" title="重新提交">
                <a-icon
                  style="font-size: 22px;margin-left: 8px"
                  type="edit"
                  @click="redoSubmit(record)"
                ></a-icon>
              </a-tooltip>
            </template>
            <!--                <a-tooltip placement="top" title="查看关联活动">-->
            <!--                  <a-icon style="font-size: 22px;margin-left: 8px" type="link"></a-icon>-->
            <!--                </a-tooltip>-->
          </template>
          <template v-if="is_my === 2">
            <a-tooltip placement="top" title="审核">
              <a-icon
                style="font-size: 22px;"
                type="form"
                @click="checkMaterial(record)"
              ></a-icon>
            </a-tooltip>
          </template>
        </template>
      </a-table-column>
    </a-table>

    <!-- 创建 -->
    <a-modal
      :visible="visible"
      :width="760"
      okText="提交"
      cancelText="取消"
      @ok="_ok"
      @cancel="_cancel"
      :title="submitType ? '添加资料' : '修改资料'"
    >
      <a-form-model
        ref="ruleForm"
        :model="uploadForm"
        :rules="rules"
        :label-col="{ span: 4 }"
        :wrapper-col="{ span: 14 }"
      >
        <a-form-model-item label="资料名称" prop="name">
          <a-input
            class="vd-input-s"
            placeholder="资料名称 20 字以内"
            v-model="uploadForm.name"
          />
          <span class="common-mute"> {{ uploadForm.name.length }}/20</span>
        </a-form-model-item>
        <a-form-model-item label="资料简介" prop="describe">
          <a-textarea
            class="vd-input-m"
            v-model="uploadForm.describe"
            placeholder="资料简介 50 字以内"
          >
          </a-textarea>
          <span class="common-mute"> {{ uploadForm.describe.length }}/50</span>
        </a-form-model-item>
        <a-form-model-item label="学科门类" prop="category">
          <a-select
            style="width: 216px"
            v-model="uploadForm.category"
            placeholder="请选择学科门类"
            @change="subChange"
          >
            <template v-for="item in subList">
              <a-select-option :key="item.id">
                {{ item.nickname }}
              </a-select-option>
            </template>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="资料封面" prop="head_pic">
          <a-input hidden></a-input>
          <a-upload
            accept=".jpg,.png.jpeg"
            :action="upload_url"
            @change="onChange"
            :beforeUpload="beforeUpload"
            list-type="picture"
            :file-list="headFileList"
          >
            <div>
              <template v-if="headFileList.length === 0">
                <a-button icon="cloud-upload"> 上传图片</a-button>
                <span class="common-mute">
                  请上传宽高比为 200 : 260px，并且小于1M的图片
                </span>
              </template>
            </div>
          </a-upload>
        </a-form-model-item>
        <!-- <a-form-model-item label="资料类型" prop="type">
             <a-radio-group v-model="uploadForm.type">
               <a-radio :value="1"> 文字材料</a-radio>
               <a-radio :value="2"> 视频材料</a-radio>
             </a-radio-group>
           </a-form-model-item>-->
        <!--          <a-form-model-item label="能否下载" prop="is_download">-->
        <!--            <a-radio-group v-model="uploadForm.is_download">-->
        <!--              <a-radio :value="1" disabled> 可下载</a-radio>-->
        <!--              <a-radio :value="0"> 不可下载</a-radio>-->
        <!--            </a-radio-group>-->
        <!--          </a-form-model-item>-->
        <a-form-model-item label="保存时间" prop="due_time">
          <a-date-picker
            :showToday="false"
            v-model="uploadForm.due_time"
            placeholder="资料过期时间"
            format="YYYY-MM-DD"
            @change="dateChange"
            :disabled-date="disabledDate"
          >
            <template slot="renderExtraFooter">
              <a-tag @click="selectDate(7)"> 7天</a-tag>
              <a-tag @click="selectDate(30)"> 1个月</a-tag>
              <a-tag @click="selectDate(90)"> 3个月</a-tag>
              <a-tag @click="selectDate(180)"> 半年</a-tag>
              <a-tag @click="selectDate(360)"> 一年</a-tag>
            </template>
          </a-date-picker>
        </a-form-model-item>
        <a-form-model-item label="上传资料" prop="material">
          <a-input hidden v-model="uploadForm.material" />

          <a-upload
            :accept="uploadForm.type === 1 ? '.pdf' : '.mp4'"
            :action="upload_url"
            :data="{ alias: this.uploadForm.name, remark: '白皮书资料' }"
            @change="onChanges"
            :beforeUpload="beforeMaterial"
            :file-list="materialFileList"
          >
            <div>
              <template v-if="materialFileList.length === 0">
                <a-button icon="cloud-upload"> 上传资料</a-button>
                <span class="common-mute">
                  {{
                    uploadForm.type === 1
                      ? ' 请上传.pdf，并且小于10M'
                      : ' 请上传.mp4格式，并且小于50M'
                  }}
                </span>
              </template>
            </div>
          </a-upload>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!-- 审核 -->
    <a-modal
      :visible="checkVisible"
      :dialogStyle="{ top: '20px' }"
      :keyboard="false"
      :maskClosable="false"
      :closable="false"
      :width="760"
      okText="通过"
      cancelText="驳回"
      @ok="okCheck"
      @cancel="cancelCheck"
      title="审核材料"
    >
      <div
        style="max-height: 300px;overflow-y: scroll;border: 1px black solid;margin-bottom: 15px"
      >
        <pdf :src="checkData.material"></pdf>
      </div>
      <a-form-model
        ref="checkForm"
        :model="checkForm"
        :rules="checkRules"
        :label-col="{ span: 4 }"
        :wrapper-col="{ span: 14 }"
      >
        <a-form-model-item label="述驳回原因" prop="reason">
          <a-textarea
            placeholder="请简述驳回原因 200 字以内，若审核通过则无须填写。"
            class="vd-input-m"
            v-model="checkForm.reason"
          ></a-textarea>
          <span class="common-mute"> {{ checkForm.reason.length }}/200</span>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!-- 关联关系展示 -->
    <a-modal
      :visible="relationVisible"
      :footer="null"
      @cancel="cancelRelation"
      title="关联活动"
    >
      <a-table
        :data-source="relationList"
        size="small"
        :pagination="false"
        row-key="activity_id"
      >
        <a-table-column
          title="活动id"
          align="center"
          data-index="activity_id"
        />
        <a-table-column title="活动名称" data-index="activity_name" />
        <a-table-column title="活动状态" data-index="activity_status">
          <template slot-scope="text">
            <a-tag v-if="text === 1" color="blue">正常</a-tag>
            <a-tag v-else-if="text === 2" color="orange">活动过期</a-tag>
          </template>
        </a-table-column>
        <a-table-column title="查看活动">
          <template slot-scope="record">
            <a-icon
              class="common-icon"
              type="swap-right"
              @click="jumpToActivity(record.activity_id)"
            />
          </template>
        </a-table-column>
      </a-table>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'
import 'moment/locale/zh-cn'
import {
  book_modify_material,
  getBookMaterial,
  check_book_material,
  material_repeat_name,
  get_relation,
} from '@/api/book'
import { get_sub } from '@/api'
import pdf from 'vue-pdf'

export default {
  components: { pdf },
  name: 'Material',
  data() {
    return {
      is_my: 1,
      upload_url: this.UPLOAD_URL,
      name: undefined,
      status: undefined,
      type: undefined,
      category: undefined,
      visible: false,
      submitType: true,
      list: [],
      relationList: [],
      tableSpinning: false,
      uploadForm: {
        id: undefined,
        name: '',
        describe: '',
        is_download: 0,
        type: 1,
        category: undefined,
        head_pic: '',
        material: '',
        due_time: '',
      },
      headFileList: [],
      materialFileList: [],
      rules: {
        name: [
          { required: true, message: '请填写资料名称', trigger: 'blur' },
          { max: 20, message: '名称限20字以内', trigger: 'change' },
        ],
        describe: [
          { required: true, message: '请填写资料简介', trigger: 'blur' },
          { max: 50, message: '简介限50字以内', trigger: 'change' },
        ],
        category: [
          { required: true, message: '请选择学科门类', trigger: 'blur' },
        ],
        head_pic: [{ required: true, message: '请上传封面', trigger: 'blur' }],
        type: [{ required: true, message: '请选择资料类型', trigger: 'blur' }],
        is_download: [
          { required: true, message: '请设置学员能否下载', trigger: 'blur' },
        ],
        due_time: [
          { required: true, message: '请设置保存时间', trigger: 'blur' },
        ],
        material: [{ required: true, message: '请上传资料', trigger: 'blur' }],
      },
      pagination: {
        total: 1,
        current: 1,
        pageSize: 10,
        hideOnSinglePage: true,
        onChange: (page) => {
          this.pagination.current = page
          this.getData()
        },
      },
      subList: [],
      checkVisible: false,
      relationVisible: false,
      checkData: {},
      checkForm: {
        reason: '',
      },
      checkRules: {
        reason: [
          { max: 200, message: '驳回理由限200字以内', trigger: 'change' },
        ],
      },
      setTimeoutListen: null,
    }
  },
  mounted() {
    this.tableSpinning = true
    this.getSub()
    this.getData()
  },
  methods: {
    /* 学科 */
    getSub() {
      get_sub('item_type').then((res) => {
        if (res['code'] === 1) {
          this.subList = res['list']
        }
      })
    },
    /* 获取数据 */
    getData() {
      getBookMaterial({
        status: this.status,
        is_my: this.is_my,
        name: this.name,
        type: this.type,
        category: this.category,
        current: this.pagination.current,
        page_size: this.pagination.pageSize,
      }).then((res) => {
        this.tableSpinning = false
        if (res['code'] === 1) {
          this.list = res['list']
          this.pagination.total = res['count']
          this.$message.destroy()
        } else {
          this.list = []
          this.pagination.total = 0
        }
      })
    },
    _ok() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          book_modify_material(this.uploadForm).then((res) => {
            if (res['code'] === 1) {
              this.visible = !this.visible
              this.tableSpinning = true
              this.getData()
              this.$message.success({
                content: res['msg'],
                key: 'addBookMaterial',
              })
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    _cancel() {
      this.visible = !this.visible

      this.uploadForm.id = undefined
      this.uploadForm.name = ''
      this.uploadForm.describe = ''
      this.uploadForm.is_download = 0
      this.uploadForm.type = 1
      this.uploadForm.category = undefined
      this.uploadForm.head_pic = ''
      this.uploadForm.material = ''
      this.uploadForm.due_time = ''

      this.$refs.ruleForm.resetFields()
    },
    seeMaterial(e) {
      window.open(e.material, '_blank')
    },
    // 查看关联关系
    getRelation(record) {
      get_relation({
        id: record.id,
      }).then((res) => {
        if (res['code'] === 1) {
          // 显示关联列表  展示数据
          this.relationList = res['list']
          this.relationVisible = true
        } else {
          this.$message.warning(res['msg'])
        }
      })
    },
    redoSubmit(record) {
      // 重新提交数据
      this.visible = true
      this.submitType = false
      this.uploadForm.id = record.id
      this.uploadForm.name = record.name
      this.uploadForm.describe = record.describe
      this.uploadForm.category = record.category

      this.uploadForm.head_pic = record.head_pic
      let name = this.$HelperUtil.getUrlFilename(record.head_pic)
      this.headFileList = [
        {
          uid: '-1',
          name: name[0],
          status: 'done',
          url: record.head_pic,
        },
      ]
      this.uploadForm.due_time = moment(record.due_time)

      this.uploadForm.material = record.material
      let m_name = this.$HelperUtil.getUrlFilename(record.material)
      this.materialFileList = [
        {
          uid: '-1',
          name: m_name[0],
          status: 'done',
          url: record.material,
        },
      ]
    },
    checkMaterial(e) {
      this.checkData = e
      this.checkVisible = !this.checkVisible
    },
    okCheck() {
      check_book_material({
        check: 'pass',
        id: this.checkData.id,
      }).then((res) => {
        if (res['code'] === 1) {
          this.$message.success('审核完成')
          this.checkVisible = false
          this.getData()
        } else {
          this.$message.warning(res['msg'])
        }
      })
    },
    cancelCheck() {
      // 驳回
      check_book_material({
        check: 'back',
        id: this.checkData.id,
        reason: this.checkForm.reason,
      }).then((res) => {
        if (res['code'] === 1) {
          this.$message.success({
            content: '资料被驳回!',
            key: 'checkBookMaterial',
          })
          this.checkVisible = false
          this.getData()
        } else {
          this.$message.warning({
            content: res['msg'],
            key: 'checkBookMaterial',
          })
        }
      })
    },
    jumpToActivity(id) {
      this.$router.push({
        path: '/book/detail/add',
        query: {
          id: id,
        },
      })
    },
    cancelRelation() {
      this.relationVisible = false
      this.relationList = []
    },
    subChange(e) {
      this.uploadForm.category = e
    },
    search() {
      this.pagination.current = 1
      this.tableSpinning = true
      this.getData()
    },
    searchInput() {
      if (this.setTimeoutListen === null) {
        this.setTimeoutListen = setTimeout(() => {
          this.setTimeoutListen = null
          this.search()
        }, 500)
      }
    },
    redo() {
      this.pagination.current = 1
      this.name = this.type = this.category = undefined
      this.tableSpinning = true
      this.getData()
    },
    change_my(e) {
      if (this.is_my !== e) {
        this.is_my = e
        this.pagination.current = 1
        this.name = this.type = this.category = undefined
        this.tableSpinning = true
        this.getData()
      }
    },
    upload_material() {
      this.visible = !this.visible
      this.submitType = true
    },
    // 日期 -------------
    moment,
    selectDate(date) {
      switch (date) {
        case 7:
          this.uploadForm.due_time = moment()
            .add(1, 'weeks')
            .endOf('days')
          break
        case 30:
          this.uploadForm.due_time = moment()
            .add(1, 'months')
            .endOf('days')
          break
        case 90:
          this.uploadForm.due_time = moment()
            .add(3, 'months')
            .endOf('days')
          break
        case 180:
          this.uploadForm.due_time = moment()
            .add(6, 'months')
            .endOf('days')
          break
        case 360:
          this.uploadForm.due_time = moment()
            .add(1, 'years')
            .endOf('days')
          break
        default:
          console.log('未知类型')
          break
      }
    },
    dateChange(dates) {
      this.uploadForm.due_time = dates
    },
    disabledDate(current) {
      // Can not select days before today and today
      return current && current < moment().startOf('day')
    },
    /* 图片 ----------- */
    beforeUpload(file) {
      //读取图片数据
      return new Promise((resolve, reject) => {
        let reader = new FileReader()
        reader.onload = (e) => {
          // //加载图片获取图片真实宽度和高度
          let image = new Image()

          image.onload = () => {
            let height = image.height
            let width = image.width
            if (height / width === 1.3) {
              resolve(true)
            } else {
              this.$message.info('图片比例不正确')
              reject('比例错误')
            }
          }
          image.src = e.target.result
        }
        reader.readAsDataURL(file)
      })
    },
    onChange(e) {
      let status = e.file.status
      if (status === 'uploading') {
        this.headFileList = e.fileList
      } else if (status === 'done') {
        console.log(e.fileList)
        e.fileList.forEach((item) => {
          if (item.status === 'done') {
            if (item.response.code === 1) {
              item.thumbUrl = item.response.info.web_url
              this.uploadForm.head_pic = item.response.info.web_url
            }
          }
          return item
        })
        this.headFileList = e.fileList
      } else if (status === 'error') {
        console.log('上传错误')
      } else if (status === 'removed') {
        this.headFileList = e.fileList
      }
    },
    /* 资料 ----------- */
    beforeMaterial(file) {
      return new Promise((resolve, reject) => {
        // 判断有无资料名称
        if (!this.uploadForm.name) {
          this.$message.warning('请先填写资料名称!')
          reject(false)
        } else {
          // 检测是否合法
          if (!this.$HelperUtil.strCheck(this.uploadForm.name)) {
            this.$message.warning('资料名称不合法!')
            reject(false)
          }
          // 判断资料名是否重复
          material_repeat_name({ name: this.uploadForm.name }).then((res) => {
            if (res['code'] === 1) {
              let size = 10
              if (file.size >= 1024 * 1024 * size) {
                this.$message.warning('请上传小于 ' + size + 'M 的资料')
                reject(false)
              } else {
                resolve(true)
              }
            } else {
              this.$message.warning(res['msg'])
              reject(false)
            }
          })
        }
      })
    },
    /* 优化后的回调 */
    onChanges(e) {
      let status = e.file.status
      let file = e.file
      if (status === 'uploading') {
        file.name = this.uploadForm.name + '.pdf'
      } else if (status === 'done') {
        if (file.response.code === 1) {
          this.uploadForm.material = file.thumbUrl = file.response.info.web_url
        } else {
          this.$message.error(file.response.msg)
        }
      }
      this.materialFileList = e.fileList
    },
  },
}
</script>

<style scoped></style>
